import React from "react";

import styles from "./feedback-status.scss";

const FeedbackStatus = ({ heading, description }) => {
  return (
    <div className={styles.feedback_status}>
      <div className={styles.feedback_status_heading}>{heading}</div>
      <div className={styles.feedback_status_content}>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default FeedbackStatus;
